import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
	selector: "app-application-help",
	templateUrl: "./application-help.component.html",
	styleUrls: ["../../focuspay.style.scss"],
})
export class ApplicationHelpComponent implements OnInit {
	@Input() displayModal: string;
	@Output() displayModalEvent = new EventEmitter<string>();

	constructor() {}

	ngOnInit(): void {}
}
